function cleanUrl(URL, pathOnly) {
  return !!URL && (!!pathOnly ? URL.replace(/(^\w+:|^)\/\/(.*?\/)/, '') : URL.replace(/(^\w+:|^)\/\//, ''))
}

export default cleanUrl
